import { axiosAuth } from "src/redux/api/common";
import { dietrydata, EditDietFormValues } from "../schema/dietary-report.schema";
import { PRODUCT_BASE_URL } from "src/redux/api/appConst";

export async function addDietryReport(
  values: dietrydata,
  customer_id: number,
  member_id: number,
) {
  const payload = {
    customer_id: customer_id,
    member_id: member_id,
    day: values.day,
    morning_meal_fast: values.morning_meal_fast,
    morning_meal_fast_time: values.morning_meal_fast_time,
    lunch: values.lunch,
    lunch_time: values.lunch_time,
    evening_snacks: values.evening_snacks,
    evening_snacks_time: values.evening_snacks_time,
    dinner: values.dinner,
    dinner_time: values.dinner_time,
    anything_between: values.anything_between,
    anything_between_time: values.anything_between_time,
  };

  const api = axiosAuth();
  const res = await api.post(`${PRODUCT_BASE_URL}/admin/dietary-recalls`, payload);

  return res.data;
}

export const getDietaryReports = async (memberId: number) => {
  const api = axiosAuth();

  const { data } = await api.get(
    `${PRODUCT_BASE_URL}/admin/dietary-recalls?member_id=${memberId}`,
  );

  return data.data.dietary_recalls;
};

export const editDietReport = async (
  reportId: string,
  values: EditDietFormValues,
) => {
  const api = axiosAuth();

  const { data } = await api.patch(
    `${PRODUCT_BASE_URL}/admin/dietary-recalls/${reportId}`,
    values,
  );

  return data.data;
};
